"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUIContext = exports.UIContextProvider = exports.useUIProviderProps = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const UI_1 = require("@reactionable/core/lib/ui/UI");
const ErrorAlert_1 = require("./alert/ErrorAlert");
const WarningAlert_1 = require("./alert/WarningAlert");
const Confirmation_1 = require("./confirmation/Confirmation");
const useForm_1 = require("./form/useForm");
const useFormField_1 = require("./form/useFormField");
const Layout_1 = require("./layout/Layout");
const Link_1 = require("./link/Link");
const Loader_1 = require("./loader/Loader");
const Modal_1 = require("./modal/Modal");
const useModalForm_1 = require("./modal/useModalForm");
const ErrorNotification_1 = require("./notification/ErrorNotification");
const SuccessNotification_1 = require("./notification/SuccessNotification");
function useUIProviderProps(props) {
    return UI_1.useUIProviderProps(Object.assign({ useLoader: Loader_1.useLoader,
        useSuccessNotification: SuccessNotification_1.useSuccessNotification,
        useErrorNotification: ErrorNotification_1.useErrorNotification,
        useErrorAlert: ErrorAlert_1.useErrorAlert,
        useWarningAlert: WarningAlert_1.useWarningAlert,
        useConfirmation: Confirmation_1.useConfirmation,
        useLayout: Layout_1.useLayout,
        useForm: useForm_1.useForm,
        useFormField: useFormField_1.useFormField,
        useModal: Modal_1.useModal,
        useModalForm: useModalForm_1.useModalForm,
        useLink: Link_1.useLink }, props));
}
exports.useUIProviderProps = useUIProviderProps;
const UIContextProvider = (props) => {
    const uiContextProviderProps = Object.assign(Object.assign({}, useUIProviderProps()), props);
    return jsx_runtime_1.jsx(UI_1.UIContextProvider, Object.assign({}, uiContextProviderProps), void 0);
};
exports.UIContextProvider = UIContextProvider;
function useUIContext() {
    return UI_1.useUIContext();
}
exports.useUIContext = useUIContext;
//# sourceMappingURL=UI.js.map